module.exports = __webpack_public_path__ + "img/手机长图背景.710bc176.png";